module.exports = __webpack_public_path__ + "img/icn_transportation2.22ba9c65.png";